<template>
  <div class="address-form">
    <div style="height: 10px"></div>
    <van-cell-group>
      <van-field
        input-align="right"
        v-model="formData.name"
        label="联系人"
        :error="formValidate && !formData.name"
        placeholder="请输入联系人"
      />
      <van-field
        input-align="right"
        v-model="formData.phone"
        label="手机号码"
        :error="formValidate && !formData.phone"
        type="number"
        placeholder="请输入手机号码"
      />
      <van-field
        input-align="right"
        @click="area_show = true"
        readonly
        :value="formData.province + formData.city + formData.county"
        :error="formValidate && !formData.county"
        label="选择地区"
        placeholder="请选择地区"
      />
      <van-field
        input-align="right"
        v-model="formData.address"
        label="详细地址"
        type="textarea"
        :error="formValidate && !formData.address"
        placeholder="请输入街道门牌信息"
      />
      <van-field
        input-align="right"
        v-model="formData.code"
        label="邮政编码" 
        type="number"
        placeholder="请输入邮政编码"
      />
      <van-cell title="是否设为默认">
        <van-switch
          size="24px"
          active-color="#FCAB15"
          v-model="formData.is_default"
        />
      </van-cell>
    </van-cell-group>
    <van-cell-group>
      <van-field
        input-align="left"
        v-model="addressarea"
        type="textarea"
        placeholder="例：张三 13800000000 江苏省南京市江北新区星火E方1栋101室" 
      />
    </van-cell-group>

    <div style="padding: 20px; text-align: right">
      <van-button round  @click.stop="getarea"  
        >识别</van-button
      >
    </div>
    <div style="padding: 20px; text-align: center">
      <van-button round size="large" @click.stop="formSave" class="save"
        >保存</van-button
      >
    </div>

    <div
      v-show="area_show"
      style="position: fixed; bottom: 0; z-index: 1000; width: 100%"
    >
      <van-popup
        style="top: 50%"
        position="bottom"
        :close-on-click-overlay="false"
        v-model="show"
      >
        <van-area
          :area-list="areaList"
          :value="formData.area_key"
          @confirm="areaConfirm"
          @cancel="areaCancel"
        />
      </van-popup>
    </div>
  </div>
</template>
<style scoped>
.address-form {
  background: #f8f8f8;
  height: 843px;
}
.van-cell:not(:last-child)::after {
  right: 16px;
}
.save {
  width: 155px;
  height: 46px;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
}
</style>
<script>
import Vue from "vue";
    import { Toast } from 'vant';
import { Popup, CellGroup, Cell, Switch, Area } from "vant";
import areaList from "@/utils/area";

export default {
  name: "AddressAdd",
  data() {
    return {
      show: true,
      addressarea: "",
      formData: {
        name: "",
        phone: "",
        area_names_string: "",
        area_key: "",
        address: "",
        province: "",
        city: "",
        county: "",
        is_default: true,
        code:""
      },
      selectAddress: {},
      areaList: areaList,
      list: [],
      area_show: false,
      formValidate: false,
    };
  },
  mounted() {
    document.title = "新增收货地址";
  },
  components: {
    [Popup.name]: Popup,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Area.name]: Area,
  },
  methods: {
    onSelect(address) {
      let that = this;
      that.selectAddress = address;
      that.onChange();
    },
    /*onClose() {
                this.showAdd = false;
                this.$emit("onClose", {})
            },*/

    onChange() {
      /*let that = this;
                // console.log('onChange',{ address: that.data.selectAddress, address_id: that.data.selectAddress.id });
                this.$emit("onChange", { address: that.selectAddress, address_id: that.selectAddress.id})
                that.onClose()*/
      // this.$router.push('addresslist');
      this.$router.go(-1);
    },
    areaConfirm(data) {
      let that = this;
      console.log(data);
      that.formData.province = data[0].name;
      that.formData.city = data[1].name;
      that.formData.county = data[2].name;
      that.formData.area_key = data[2].code;
      that.formData.area_names_string =
        data[0].name + "-" + data[1].name + "-" + data[2].name;
      this.area_show = false;
    },
    areaCancel() {
      this.area_show = false;
    },

    getarea() {
      let that = this;
      if(!this.addressarea){
        Toast('请输入完整的地址信息')
      }
      this.$api.get(
        "/api/user/smartParse",
        { address: this.addressarea },
        (res) => {
          console.log("aaa", res);
          that.formData.name = res.data.name
          that.formData.phone= res.data.phone
          that.formData.address= res.data.detail[3].name
          that.formData.province= res.data.detail[0].name
          that.formData.area_key= res.data.detail[2].area_key
          that.formData.city= res.data.detail[1].name
          that.formData.county= res.data.detail[2].name
        },(res) => {
          console.log("aaa", res); 
        Toast(res.msg)
        }
      );
    },

    formSave() {
      let that = this;
      that.formValidate = true;
      console.log("that.formData", that.formData);
      for (let field in that.formData) {
        if (!that.formData[field] && (field == "name" || field == "phone"  || field =='county' || field =='address')) {
          return;
        }
      }
      this.$api.get(
        "/api/user/addressAdd",
        {
          //$name, $phone, $address ,$area_key,$province,$city,$county,$is_default=''
          name: that.formData.name,
          phone: that.formData.phone,
          address: that.formData.address,
          province: that.formData.province,
          area_key:that.formData.area_key,
          city: that.formData.city,
          county: that.formData.county,
          code:that.formData.code,
          is_default: that.formData.is_default ? 1 : 2,
        },
        (res) => {
          console.log(res);
          that.selectAddress = res.data;
          that.formValidate = false;
          that.formData = {
            name: "",
            phone: "",
            area_names_string: "",
            area_key: "",
            address: "",
            province: "",
            city: "",
            code:'',
            county: "",
            is_default: true,
          };
          that.onChange();
        }
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// AddressAdd.vue?480d5c9f